export default __webpack_public_path__ + "static/Speedee_W_Bd-0d140e263fe185a9dd99f026ac7d5205.woff2";